import type { RestaurantWithEventSpaces } from "@/types/restaurant";
import { getNeighborhoodDisplay } from "@/utils/neighborhoodFormatting";

interface CardHeaderProps {
  restaurant: RestaurantWithEventSpaces;
}

export const CardHeader = ({ restaurant }: CardHeaderProps) => {
  return (
    <div className="p-4 pb-2">
      <h3 className="text-lg font-semibold text-primary leading-tight mb-1">{restaurant.name}</h3>
      <p className="text-sm text-muted-foreground">
        {getNeighborhoodDisplay(restaurant.neighborhood)}
      </p>
    </div>
  );
};